// extracted by mini-css-extract-plugin
export default {"container":"content_container__wuYIk","bottomText":"content_bottomText__070qB"};